module.exports = __webpack_public_path__ + "img/1x.821713f.jpg";